import React, { memo } from 'react';
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import type { ReactNode } from 'react';
import type { StatisticsColumn } from './sources/LayerStatisticsSourceTypes';

type LayerStatisticsDataTableProps = {
  columns: StatisticsColumn[];
  items: ReactNode[];
};

const LayerStatisticsDataTable = ({ columns, items }: LayerStatisticsDataTableProps) => {
  return (
    <Box>
      <Table className={'statistics-table'}>
        <TableHead key={'header'}>
          <TableRow key={'headerRow'}>
            {columns.map((column, index) => (
              <TableCell
                key={'headerCell' + index}
                align="left"
                padding="none"
                style={{ width: '33%' }}
              >
                {column.text}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody key={'body'}>{items}</TableBody>
      </Table>
    </Box>
  );
};

export default memo(LayerStatisticsDataTable);
